import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACRiskIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1207 6.19315C12.6598 5.27311 11.3468 5.27291 10.8857 6.19273L5.62265 16.6898C5.20591 17.5209 5.81024 18.5 6.74007 18.5H17.2613C18.1909 18.5 18.7952 17.5213 18.3789 16.6902M18.3789 16.6902L13.1207 6.19315V6.19315M9.54476 5.52044C10.5594 3.49674 13.448 3.49731 14.4619 5.52133L19.7201 16.0184C20.636 17.8469 19.3065 20 17.2613 20H6.74007C4.69445 20 3.3649 17.8461 4.28176 16.0175L9.54476 5.52044V5.52044Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.00001C12.5523 9.00001 13 9.44773 13 10V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V10C11 9.44773 11.4477 9.00001 12 9.00001Z"
        fill="currentColor"
      />
      <path
        d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
        fill="currentColor"
      />
    </svg>
  );
};
